import { useFiltersV2Actions, useFiltersV2Select } from "PFApp/components/filters_v2";
import { FiltersV2 } from "PFTypes/filters_v2";

import { FiltersV2ListUnwrapped } from "../../components/filters_v2_list_unwrapped";

export type FiltersListProps = {
  filters: FiltersV2;
  lastFocusedFilterNameRef?: React.MutableRefObject<string | null>;
  narrow?: boolean;
  vertical?: boolean;
};

export const FiltersV2List = (props: FiltersListProps) => {
  const { searchId } = useFiltersV2Select("searchId");
  const { updateBufferedFilter } = useFiltersV2Actions();

  return <FiltersV2ListUnwrapped {...props} onUpdate={updateBufferedFilter} searchId={searchId} />;
};
